import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { ProductPrice } from 'modules/Products/drawers/ProductPrice/ProductPrice'

export const ProductPriceDrawer = ({
  priceId,
  onClose,
  showBillingScheduleInfo
}: {
  priceId: string
  onClose: () => void
  showBillingScheduleInfo?: boolean
}) => {
  const priceQuery = useQuery(dashboard20240730Client.getPrice, { id: priceId })

  const productQuery = useQuery(
    dashboardv99990101Client.getProduct,
    { id: priceQuery.data?.productId ?? '' },
    { enabled: Boolean(priceQuery.data?.productId) }
  )

  return (
    <ProductPrice
      price={priceQuery.data}
      product={productQuery.data ?? undefined}
      onClose={onClose}
      showBillingScheduleInfo={showBillingScheduleInfo}
    />
  )
}
